import { walkthroughSummaryLine, ORDER_WORDING } from "@/lib/screenWalkthrough";

/** Iter 47 — counts strip for the walkthrough page. Honest empty state, order wording always visible. */
export default function WalkthroughSummaryCards({ summary }) {
  if (!summary) return null;
  if (!summary.steps) {
    return (
      <div className="ml-card px-4 py-3 text-xs text-[var(--ml-text-secondary)]" data-testid="sw-summary" data-total="0">
        No observed screen statements yet — parse the RPG programs (EXFMT / WRITE / READ / READC) and the display-file DDS they use, then rebuild.
      </div>
    );
  }
  const f = summary.fields || {};
  const cell = (label, value, testid, tone, sub) => (
    <div className="ml-card px-4 py-3" data-testid={testid} data-value={value}>
      <div className="ml-mono text-[10px] uppercase tracking-widest text-[var(--ml-text-secondary)]">{label}</div>
      <div className="text-2xl font-semibold tabular-nums mt-1" style={tone ? { color: tone } : undefined}>{value}</div>
      {sub && <div className="text-[11px] text-[var(--ml-text-secondary)] mt-0.5">{sub}</div>}
    </div>
  );
  return (
    <div className="space-y-3" data-testid="sw-summary" data-total={summary.steps}>
      <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-3">
        {cell("Programs with screens", summary.programs, "sw-summary-programs", null, `${summary.display_files} display file${summary.display_files === 1 ? "" : "s"}`)}
        {cell("Screen statements", summary.steps, "sw-summary-steps", null, `${summary.by_status?.bound || 0} bound · ${summary.by_status?.ambiguous || 0} ambiguous · ${summary.by_status?.unresolved || 0} unresolved${summary.by_origin?.manual ? ` · ${summary.by_origin.manual} manual` : ""}`)}
        {cell("Input-capable fields", f.input || 0, "sw-summary-input", "#0043ce", "users can type into these")}
        {cell("Output / display fields", (f.output || 0) + (f.display || 0), "sw-summary-output", "#6929c4", `${f.output || 0} output · ${f.display || 0} hidden / control`)}
        {cell("Proven DB mappings", f.proven_mappings || 0, "sw-summary-proven", "#0e6027", "REF / REFFLD proven by DDS")}
        {cell("Ambiguous mappings", f.ambiguous_mappings || 0, "sw-summary-ambiguous", "#8a6d00", `${f.screen_only || 0} screen-only`)}
      </div>
      <div className="flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-[var(--ml-text-secondary)]" data-testid="sw-summary-line">
        <span>{walkthroughSummaryLine(summary)}</span>
        <span className="font-semibold text-[var(--ml-text-primary)]" data-testid="sw-order-wording">{ORDER_WORDING}</span>
        {summary.by_origin?.manual > 0 && (
          <span className="text-[#a2191f]" data-testid="sw-summary-manual">{summary.by_origin.manual} step{summary.by_origin.manual === 1 ? "" : "s"} rest on a manual binding supplied by consultant — not parser-proven.</span>
        )}
        <span>Steps follow the RPG statement order; conditional branches, loops and subfile paging are not modelled. Not a complete screen-flow analysis.</span>
      </div>
    </div>
  );
}
